import { z } from 'zod'

// Сотрудник — источник истины employee-backend (JIT-проекция Authentik).
// Профиль read-only (правится в Authentik); хаб владеет is_active. Департаменты —
// отдельная M2M-поверхность (entities/department), в карточке их нет.
// Схема повторяет wire-контракт EmployeeView (huma v2, openapi.json): все поля
// обязательны, «пустые» значения приходят пустыми строками.

export const EmployeeSchema = z.object({
  id: z.string(),
  subject: z.string(),
  username: z.string(),
  full_name: z.string(),
  email: z.string(),
  role: z.string(),
  is_active: z.boolean(),
  // Признак доставляемости алертов. Сам telegram_id — контакт, его бэкенд отдаёт
  // только m2m-потребителю (боту); хабу видна лишь связка «есть/нет».
  telegram_linked: z.boolean(),
  // Последняя увиденная зона устройства сотрудника (пустая = не видели). Факт, а
  // не настройка: её переставляет SPA, а показ времени берёт зону у устройства.
  timezone: z.string().default(''),
  version: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type Employee = z.infer<typeof EmployeeSchema>

// huma-обёртки ответов: одиночный — {data}; список — {data,total,page,size},
// data nullable (Go-бэкенд отдаёт null на пустую выборку). $schema игнорируется.
export const EmployeeResponseSchema = z.object({ data: EmployeeSchema })

export const EmployeeListSchema = z.object({
  data: z.array(EmployeeSchema).nullable(),
  total: z.number(),
  page: z.number(),
  size: z.number(),
})

// Тело PATCH /employees/{id} (admin): только is_active; version обязателен
// (optimistic lock wire-контракта UpdateInputBody).
export interface EmployeeInput {
  is_active: boolean
  version: number
}
